import React, { useRef, useState, useEffect } from 'react';
import './trending.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
import SEO from '../../seo/SEO';
function DeviTemple() {

   const vrShowData = [
  {
    id: 1,
    title: "Bhadrakali Temple",
    image: "/assets/trending/bhadrakali-temple.webp",
  },
  {
    id: 2,
    title: "Maa Taratarini Temple",
    image: "/assets/trending/maa-taratarini.webp",
  },
  {
    id: 3,
    title: "Vimala Temple",
    image: "/assets/trending/vimala.webp",
  },
  {
    id: 4,
    title: "Kamakhya Temple",
    image: "/assets/trending/kamakhya.webp",
  },
  {
    id: 5,
    title: "Kalighat Kali Temple",
    image: "/assets/trending/kalighat-kali.webp",
  },
  {
    id: 6,
    title: "Jwalaji Temple",
    image: "/assets/trending/jwalaji-temple.webp",
  },
  {
    id: 7,
    title: "Amba ji temple",
    image: "/assets/trending/ambeji.webp",
  },
  
];
   return (
      <>
         <SEO pageKey="deviTemple" />
         <Box className="trendingPage trendingDetail" >
            <Container maxWidth="lg">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
                     <Box className="VrBannerText">
                        <div>
                           <h1 className="mt-4">SHAKTI PEETHAS & DEVI TEMPLES</h1>
                           <p>Discover the sacred Shakti Peethas and revered Devi temples where the Divine Mother is worshipped in her many powerful forms. Explore their spiritual significance, ancient legends, and timeless traditions across India.
                           </p>
                           {/* <div className="d-flex gap-3 bannerButton">
                              <Box className="text-center mt-lg-3">
                                 <a href="#formBox" className="btn btn-success text-dark"><i className="fa fa-play ms-1 text-dark"></i> Play </a>
                              </Box>
                              <Box className="text-center mt-lg-3">
                                 <a href="/assets/trending/guideline.pdf" target="_blank" className="btn btn-warning text-dark"><i className="fa fa-arrow-right me-1 text-dark"></i>More Info </a>
                              </Box>
                           </div> */}
                        </div>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         <section className="darkTheme">
            
            <Box className="trendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     
                     {vrShowData.map((item) => (
                        <Grid
                           key={item.id}
                           size={{ xl: 3, lg: 3, md: 4, sm: 4, xs: 6 }}
                        >
                           <div className="swiperCitySlider">
                              <div className="templeCard templeDetailCard">
                              <img src={item.image} alt={item.title} />

                              <div className="overlay"></div>

                              <div className="cardContent">
                                 <h5>{item.title}</h5>
                              </div>
                              </div>
                           </div>
                        </Grid>
                        ))}


                     
                     
                  </Grid>


               </Container>
            </Box>
         </section>
      </>
   );
}
export default DeviTemple;